import styled from 'styled-components';
import { IconTertiaryButton } from '../button';
import { Paragraph } from '../typographies';
import { Red, White } from '../../colors';
import { SCREEN_SIZE } from '../grid';
const GenericToaster = styled.div `
    display: flex;
    min-height: 87px;
    width: 320px;
    border-radius: 4px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.1);
    background-color: ${White.normal};
`;
export const ToasterDivider = styled.div `
    width: 10px;
    border-radius: 4px 0 0 4px;
    background-color: ${Red.normal};
`;
//@ts-ignore
export const ToasterMessage = styled(Paragraph) `
    padding: 0 30px;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
`;
export const ToasterCloseButton = styled(IconTertiaryButton) `
    margin: 5px 10px 0 0;
    min-height: 15px;
    min-width: 15px;
`;
//@ts-ignore
export const Toaster = styled(GenericToaster) `
    position: fixed;
    margin-right: 50px;
    top: 100px;
    right: 80px;
    z-index: 900000;
    animation-fill-mode: forwards;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        display: none;
    }
`;
export const MobileToaster = styled(GenericToaster) `
    position: absolute;
    z-index: 900000;  
    min-height: 70px;
    width: 90%;
    top: 20% !important;
    position: absolute;
    display: none;
    left: 0px;
    margin: 0 5%;
    animation-fill-mode: forwards;
    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        display: flex;
    }
`;
//# sourceMappingURL=toaster.styled.js.map